const DEFAULT_VIEW = '/admin';

export default DEFAULT_VIEW;
